import axios from "./AxiosClient";

const url = `/api`;

const ProjectManagmentService = {
  getProjects: (id, page = 1) => {
    return axios.get(`${url}/forms/users/${id}?page=${page}`);
  },
  // getProjects: (id) => {
  //   return axios.get(`${url}/forms/users/${id}`);
  // },
};

export default ProjectManagmentService;
